<div *ngIf="dataIsReady" class="water-container">
  <div class="water-title">آب ({{ waterCount }} لیوان)</div>
  <div class="water-count">مقدار پیشنهادی: {{ suggestedWater }} لیوان</div>
  <div class="water-holder">
    <div *ngFor="let water of waters; let i = index" class="water-glass">
      <img
        *ngIf="waterCount > i"
        src="assets/plan/waterFull.svg"
        (click)="removeCostumeWater(i + 1)"
      />
      <img
        *ngIf="waterCount < i"
        src="assets/plan/waterEmpty.svg"
        style="opacity: 0.5"
        (click)="addCostumeWater(i + 1)"
      />
      <img
        *ngIf="waterCount === i"
        src="assets/plan/waterAdd.svg"
        (click)="addWater()"
      />
    </div>
  </div>
</div>
<div *ngIf="!dataIsReady" class="water-container" style="height: 134px">
  <ngx-skeleton-loader
    [theme]="{
      top: '16px',
      right: '16px',
      height: '20px',
      width: '150px',
      position: 'absolute',
      'background-color': '#f8f9fa'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    [theme]="{
      top: '46px',
      right: '16px',
      height: '20px',
      width: '200px',
      position: 'absolute',
      'background-color': '#f3f4f6'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    appearance="circle"
    count="5"
    [theme]="{
      top: '81px',
      height: '34px',
      width: '34px',
      position: 'relative',
      'background-color': '#e8eaef',
      margin: '0 16px 0 0'
    }"
  ></ngx-skeleton-loader>
</div>
